import {
  ChefHat,
  Layers,
  Box,
  DollarSign,
} from 'lucide-react';

export const TABS = [
  {
    id: 'menu-items',
    label: 'Menu Items',
    href: '/recipes/menu-items',
    icon: ChefHat 
  },
  {
    id: 'sub-recipes',
    label: 'Sub-Recipes',
    href: '/recipes/sub-recipes',
    icon: Layers 
  },
  {
    id: 'components',
    label: 'Components',
    href: '/recipes/components',
    icon: Box 
  },
  {
    id: 'costing',
    label: 'Costing',
    href: '/recipes/costing',
    icon: DollarSign 
  },
];

export const RECIPE_TYPES = [
  {
    value: 'finished' as const,
    label: 'Menu Items',
    icon: ChefHat 
  },
  {
    value: 'sub-recipe' as const,
    label: 'Sub-Recipes',
    icon: Layers 
  },
  {
    value: 'component' as const,
    label: 'Components',
    icon: Box 
  },
];

export const DIETARY_OPTIONS = [
  {
    value: '',
    label: 'All Diets' 
  },
  {
    value: 'vegetarian',
    label: 'Vegetarian' 
  },
  {
    value: 'vegan',
    label: 'Vegan' 
  },
  {
    value: 'gluten-free',
    label: 'Gluten-Free' 
  },
  {
    value: 'dairy-free',
    label: 'Dairy-Free' 
  },
];
